export const SET_RISK_FACTORS = 'SET_RISK_FACTORS'
export const CLEAR_RISK_FACTORS = 'CLEAR_RISK_FACTORS'
